import { FCX, getFormattedThousand } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useCommonDataContext } from "@core/CommonDataContext";
import { useSelectFilters } from "@vms/SelectFilters/SelectFiltersContext";
import Skeleton, { SkeletonShape } from "@components/Skeleton";

const FilterResultsHeadline: FCX<{
	resultCount: number,
    isLoading?: boolean;
}> = ({
	resultCount,
    isLoading = false,
	className,
	testId,
}) => {
	const {
		periodLabel,
		isLoading: isLabelLoading,
	} = useCommonDataContext();

	const { featuredCategoryName } = useSelectFilters();

    if (isLabelLoading) {
        return null;
    }

    return (
	    <div
		    className={
				cn(
					"FilterResultsHeadline",
					className,
				)
		    }
		    data-testid={testId}
	    >
		    {
			    featuredCategoryName && (
				    <>
					    <span
						    className="FilterResultsHeadline__category-text"
						    title={featuredCategoryName}
						    data-testid="textFilterResultsHeadlineCategory"
					    >
						    {featuredCategoryName}
						</span>
					    <span> | </span>
				    </>
			    )
		    }
		    <span
			    className="FilterResultsHeadline__results-count"
			    data-testid="textFilterResultsHeadlineCount"
		    >
			    {isLoading ? (
                    <Skeleton
                        className="ItemTileMetrics__item-value"
                        shape={SkeletonShape.Text}
                        width={100}
                        height={24}
                        radius={4}
                    />
                ) : `${getFormattedThousand(resultCount)} RESULTS`}
			</span>
		    <span
			    className="FilterResultsHeadline__results-period"
			    data-testid="textFilterResultsHeadlinePeriodLabel"
		    >
			    {periodLabel}
			</span>
	    </div>
    );
};

export default FilterResultsHeadline;